import {useEffect, useState} from 'react'

const useMediaQuery = (query: string): boolean => {
    const [matches, setMatches] = useState(() => window.matchMedia(query).matches)

    useEffect(() => {
        const media = window.matchMedia(query)
        const onChange = (): void => {
            setMatches(media.matches)
        }

        media.addEventListener('change', onChange)

        return () => {
            media.removeEventListener('change', onChange)
        }
    }, [query])

    return matches
}

export default useMediaQuery
